export default __webpack_public_path__ + "static/media/settings.bc2eb266.png";